import { useTranslations } from 'next-intl';
import { BaseLineInfo } from '@/app/components/icons/BaseLineInfo';
import { SuggestFillSuccee3 } from '@/app/components/icons/SuggestFillSuccee3';
import { CustomTooltip } from '@/app/components/shared/CustomTooltip';
import { cn } from '@/app/utils';
import type { ShareStatus } from './types';

const postReferenceStatusClassMap: Record<string, string> = {
  approved: 'bg-[rgba(59,179,70,0.32)] border-[rgba(59,179,70,0.60)] border-[0.5px]',
  pending: 'bg-[rgba(0,134,255,0.36)] border-[rgba(0,134,255,0.48)] border-[0.5px]',
  rejected: 'text-system-white36 bg-system-white08',
  unspecified: '',
};

const renderStatus = (status: ShareStatus['status'], trans: ReturnType<typeof useTranslations>) => {
  if (!status) return null;
  const text = trans(status);
  if (status === 'approved') {
    return (
      <>
        <SuggestFillSuccee3 className="size-3.5" />
        {text}
      </>
    );
  }
  if (status === 'rejected') {
    return (
      <>
        {text}
        <CustomTooltip content={trans('rejectTip')} disableHoverableContent={true} sideOffset={2}>
          <div>
            <BaseLineInfo className="size-3.5" />
          </div>
        </CustomTooltip>
      </>
    );
  }
  return text;
};

interface PostStatusTagProps {
  tag: ShareStatus;
  className?: string;
}

export const PostStatusTag = ({ tag, className }: PostStatusTagProps) => {
  const trans = useTranslations('elements.submit');
  return (
    <div
      className={cn(
        'flex items-center gap-1 rounded-full px-2 py-0.5 text-system-white text-xs',
        tag.status && postReferenceStatusClassMap[tag.status],
        className,
      )}
    >
      {renderStatus(tag.status, trans)}
    </div>
  );
};
